// Hook para centralizar queries de produtos com estrutura hierárquica
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";

// Query keys organizadas hierarquicamente
export const produtoKeys = {
  all: ["produto"] as const,
  detail: (id: number) => [...produtoKeys.all, "detail", id] as const,
  precosEmpresa: (id: number) => [...produtoKeys.all, "precos-empresa", id] as const,
  historicoPrecos: (id: number, empresas?: string) => [...produtoKeys.all, "historico-alteracao-precos", id, empresas] as const,
  movimentosEstoque: (id: number, empresas?: string) => [...produtoKeys.all, "movimentos-estoque", id, empresas] as const,
  historicoVendas: (id: number, empresas?: string) => [...produtoKeys.all, "historico-vendas", id, empresas] as const,
  lista: (filters: any) => [...produtoKeys.all, "lista", filters] as const,
  resumo: (filters: any) => [...produtoKeys.all, "resumo", filters] as const,
  departamentos: () => [...produtoKeys.all, "departamentos"] as const,
};

// Hook para invalidar queries de produto
export const useProdutoInvalidation = () => {
  const queryClient = useQueryClient();

  const invalidateAll = () => {
    queryClient.invalidateQueries({ queryKey: produtoKeys.all });
  };

  const invalidateProduto = (produtoId: number) => {
    queryClient.invalidateQueries({ queryKey: ["produto", produtoId] });
  };

  const invalidateProdutoDetail = (produtoId: number) => {
    queryClient.invalidateQueries({ queryKey: produtoKeys.detail(produtoId) });
  };

  const invalidateProdutoHistoricos = (produtoId: number) => {
    queryClient.invalidateQueries({ queryKey: ["produto", "historico-alteracao-precos", produtoId] });
    queryClient.invalidateQueries({ queryKey: ["produto", "movimentos-estoque", produtoId] });
    queryClient.invalidateQueries({ queryKey: ["produto", "historico-vendas", produtoId] });
  };

  const invalidateProdutoPrecos = (produtoId: number) => {
    queryClient.invalidateQueries({ queryKey: produtoKeys.precosEmpresa(produtoId) });
  };

  const invalidateListas = () => {
    queryClient.invalidateQueries({ queryKey: ["produto", "lista"] });
    queryClient.invalidateQueries({ queryKey: ["produto", "resumo"] });
  };

  return {
    invalidateAll,
    invalidateProduto,
    invalidateProdutoDetail,
    invalidateProdutoHistoricos,
    invalidateProdutoPrecos,
    invalidateListas,
  };
}; 